import { render, staticRenderFns } from "./BuscarBaseComponent.vue?vue&type=template&id=46b65fc6"
import script from "./BuscarBaseComponent.vue?vue&type=script&lang=js"
export * from "./BuscarBaseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports